import React, { useEffect, useState } from 'react';
import Dialog from '@material-ui/core/Dialog';
import {useDispatch, useSelector} from 'react-redux';
import { makeStyles } from '@material-ui/core/styles';
import Fade from '@material-ui/core/Fade';
import axios from 'axios';
import Typography from '@material-ui/core/Typography';
import IconButton from '@material-ui/core/IconButton';
import Button from '@material-ui/core/Button';
import KeyboardArrowLeftOutlinedIcon from '@material-ui/icons/KeyboardArrowLeftOutlined';
import lng from '../../../misc/lng';
import envConst from '../../../misc/envConst';
import CartItemGrid from './CartItemGrid';
import DiscountDisplayGrid from './DiscountDisplayGrid';
import {setLoadingWrapper} from '../../../actions/dineIn';
import {filterVoidOrders} from '../../../utils/orderFilterFunc';
import ContactInfoDialog from '../ContactInfoDialog';
import {setSysParam} from '../../../actions';
import { useFontSize } from '../../../contexts/FontSizeContext';

const Transition = React.forwardRef(function Transition(props, ref) {
    return <Fade ref={ref} {...props} />;
  });

const {chiLng} = lng;

const useStyles = makeStyles(() => ({
    wrapper: {
        backgroundColor: '#f1efef',
        marginBottom: '100px',
    },
    titleWrapper: {

    },
    title: {
        paddingLeft: '10px',
        paddingTop: '30px',
        paddingBottom: '10px'
    },
    subTitle: {
        opacity: '0.7',
    },
    editTitle: {
        opacity: '0',
    },
    titleWrapper: {
        display: 'flex',
        justifyContent: 'space-between',
        paddingRight: '20px',
        alignItems: 'center',
        backgroundColor: 'white',
    },
    footer: {
        position: 'fixed',
        left: '0',
        bottom: '0',
        width: '100%',
        height: '100px',
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        backgroundColor: 'white',
        boxShadow: '0px 0 5px rgba(0, 0, 0, 0.8)',
        justifyContent: 'space-evenly'
    },
    addOrderBtn: {
        width: '90%',
        height: '40px',
        color: 'white',
        backgroundColor: '#666666',
        borderRadius: '10px',
        fontSize: '30px',
        lineHeight: '40px',
    },
    totalPriceWrapper: {
        display: 'flex',
        width: '100%',
        justifyContent: 'space-between',
    },
    priceTotalTitle: {
        marginLeft: '10px',
    },
    priceTotal: {
        marginRight: '10px',
    },
    productData: {
        margin: '10px 0',
        backgroundColor: 'white',
        paddingLeft: '10px',
        paddingRight: '10px',
    },
    productSummary: {
        margin: '10px 0',
        backgroundColor: 'white',
        paddingLeft: '10px',
        paddingRight: '10px',
    },
  }));


export default (props) => {
    const classes = useStyles();
    const { getFontSize } = useFontSize();

    // Dynamic font sizes
    const titleFontSize = getFontSize('sectionHeader');
    const buttonFontSize = getFontSize('buttonText');
    const {
        productData, productSummary
    } = useSelector((store) => store.productsReducer);
    const {
        tableInCharge: {
            id,
            orders,
        },
        validOrders,
    } = useSelector((store) => store.dineInReducer);
    const {priceAfterDiscount, tagSetDiscountList} = productSummary;
    const [contactInfoDialog, setContactInfoDialog] = useState(false);
    const dispatch = useDispatch();



    const handleClose = () =>{
        props.handleClose();
    }
    const handleAddOrder = (email, phone) => {
        // return if no valid contact info
        if (email.error && phone.error) {
            return;
        }
        dispatch(setLoadingWrapper('loading', ''));
        const orderTime = new Date();

        // Helper function to clean spec data for server
        const cleanSpecData = (spec) => {
            if (!spec || !Array.isArray(spec)) return spec;

            return spec.map(specGroup => ({
                mealSpecId: specGroup.mealSpecId,
                specTitle: specGroup.specTitle,
                minQty: specGroup.minQty,
                maxQty: specGroup.maxQty,
                selectionRule: specGroup.selectionRule ? {
                    ruleType: specGroup.selectionRule.ruleType || 'any',
                    min: specGroup.selectionRule.min || 0,
                    max: specGroup.selectionRule.max,
                    exact: specGroup.selectionRule.exact
                } : {
                    ruleType: 'any',
                    min: 0
                },
                specOptions: specGroup.specOptions ? specGroup.specOptions.map(opt => ({
                    specId: opt.specId,
                    specName: opt.specName,
                    specStock: opt.specStock || 0,
                    specPrice: opt.specPrice || 0,
                    printerName: opt.printerName || '',
                    printerId: opt.printerId,
                    selected: opt.selected || false
                })) : [],
                mealId: specGroup.mealId,
                qtyLimit: specGroup.qtyLimit || 1
            }));
        };

        const orderData = {
            orderTime,
            orderDetails: productData.map(
                (meal) => {
                    // Clean productSpec data - always include productSpec array (empty for non-spec items)
                    const cleanedProductSpec = meal.hasMenuSpec === 'true' && meal.productSpec ?
                        meal.productSpec.map(ps => ({
                            priceForOne: ps.priceForOne,
                            qty: ps.qty,
                            spec: cleanSpecData(ps.spec)
                        })) : [];

                    return {
                        mealCategoryId: meal.mealCategoryId,
                        mealSubCategoryId: meal.mealSubCategoryId,
                        mealId: meal.mealId,
                        name: meal.name,
                        additionalOptionCategory: meal.additionalOptionCategory,
                        additionalOptionCategoryInUsed: meal.additionalOptionCategoryInUsed,
                        qty: meal.qty,
                        price: meal.price,
                        weekday: meal.weekday,
                        img: meal.img,
                        tag: meal.tag,
                        hasMenuSpec: meal.hasMenuSpec,
                        productSpec: cleanedProductSpec,  // Use cleaned productSpec
                        printerName: meal.printerName,
                        printerId: meal.printerId,
                        simpleOptions: meal.simpleOptions,
                    };
                }
            ),
        };
        const payUrl =  `${envConst.API_PAY}`;
        axios.post(payUrl,
            {
                id,
                order: orderData,
                productSummary,
                email: email.error? '' : email.value,
                phone: phone.error? '' : phone.value,
            }
        ).then((response) => {
            if (response.data.success && response.data.redirectUrl) {
                window.location.href = response.data.redirectUrl;
            } else if (response.data.error && response.data.error === 'shop closed') {
                // const {sysParam} = response.data;
                // dispatch(setSysParam(sysParam.isShopOpen, sysParam.closeShopDescription));
                window.location.reload();
            } else {
                // Handle any other response statuses or errors here
                console.error('Unexpected response:', response);
            }
        }).catch((error) => {
            // Handle any errors that may occur during the request
            console.error('Error making API call:', error);
        });

    }

    const getConfirmedOrderBox = () => {
        if (validOrders.length > 0) {
            return (
                <React.Fragment>
                    <div className={classes.productData}>
                        <Typography variant='inherit' align='center' style={{ fontSize: titleFontSize }}>
                            {chiLng.confirmedOrderTitle}
                        </Typography>
                    </div>
                    {
                        filterVoidOrders(orders).map(
                            (order, oIdx) => {
                                return order.orderDetails.map((orderDetail, idx) => {
                                    return (
                                        <div
                                            className={classes.productData}
                                            key={`confirmedOrderCartItemGrid_${oIdx}_${idx}`}
                                        >
                                            <CartItemGrid
                                                orderDetail={orderDetail}
                                                updateCart={() => {}}
                                                selectedItemIdx={0}
                                                handleSelectItem={() => {}}
                                                idx={idx}
                                            />
                                        </div>
                                    );
                                })
                            }
                        ).flatMap(order => order)
                    }
                </React.Fragment>
            )
        }
        return null;
    }

    const getReadyToOrderBox = () => {
        if (productData.length > 0) {
            return (
                <React.Fragment>
                    <div className={classes.productData}>
                        <Typography variant='inherit' align='center' style={{ fontSize: titleFontSize }}>
                            {chiLng.readyToOrderTitle}
                        </Typography>
                    </div>
                    {
                        productData.map((orderDetail, idx) => {
                            return (
                                <div
                                    className={classes.productData}
                                    key={`orderCartItemGrid_${idx}`}
                                >
                                    <CartItemGrid
                                        orderDetail={orderDetail}
                                        idx={idx}
                                    />
                                </div>
                            );
                        })
                    }
                </React.Fragment>
            );
        }
        return null;
    }

    return(
        <Dialog
            open={props.open}
            TransitionComponent={Transition}
            onClose={handleClose}
            fullScreen
        >
            <div className={classes.wrapper}>
                <div className={classes.titleWrapper}>
                    <IconButton aria-label="back" onClick={handleClose}>
                        <KeyboardArrowLeftOutlinedIcon fontSize="large"/>
                    </IconButton>
                    <Typography className={classes.subTitle} variant='inherit' style={{ fontSize: titleFontSize }}>
                        {chiLng.shoppingCart}
                    </Typography>
                    <Typography className={classes.editTitle} variant='inherit' style={{ fontSize: titleFontSize }}>
                        {chiLng.edit}
                    </Typography>
                </div>
                
                {getReadyToOrderBox()}
                {getConfirmedOrderBox()}
                {
                    tagSetDiscountList.length > 0 ?
                    (
                        <div className={classes.productSummary}>
                            <DiscountDisplayGrid productSummary={productSummary} />
                        </div>
                    ) : null
                }



                <ContactInfoDialog
                    open={contactInfoDialog}
                    handleClose={() => {setContactInfoDialog(false)}}
                    handleConfirm={handleAddOrder}
                />
                <div className={classes.footer}>
                    <div className={classes.totalPriceWrapper}>
                        <Typography align='left' className={classes.priceTotalTitle} variant='inherit' style={{ fontSize: getFontSize('priceMain') }}>
                            {`${chiLng.shoppingCartPriceTotal}`}
                        </Typography>
                        <Typography align='right' className={classes.priceTotal} variant='inherit' style={{ fontSize: getFontSize('priceMain') }}>
                            {`$${priceAfterDiscount}`}
                        </Typography>
                    </div>
                    <Button
                        variant="contained"
                        size="large"
                        color="primary"
                        classes={{containedPrimary: classes.addOrderBtn}}
                        disabled={productData.length <= 0}
                        // onClick={handleAddOrder}
                        onClick={() => setContactInfoDialog(true)}
                        style={{ fontSize: buttonFontSize }}
                    >
                        {`${chiLng.pay}`}
                    </Button>
                </div>
            </div>
        </Dialog>
    );
};